import {NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MdInputModule, MdButtonModule, MaterialModule } from '@angular/material';
import { CreatePassRoutingModule } from './create-password.routing';
import { CreatePasswordComponent } from './create-password.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    CreatePasswordComponent
  ],
  imports: [CreatePassRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule, MdButtonModule],
  providers: [],
  bootstrap: []
})
export class CreatePassModule {
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/create-password/create-password.module.ts